<div class="route-picker-2" *ngIf="showDmsOption">
    Input Type:
    <input type="radio" [(ngModel)]="inputOption" value="DD" style="margin: 2px 5px 2px 20px;" />
    <label>Decimal Degrees</label>
    <input type="radio" [(ngModel)]="inputOption" value="DMS" style="margin: 2px 5px 2px 20px;" />
    <label>Degrees/Minutes/Seconds</label>
</div>
<div class="lat-long-container">
    <label class="lat-long" *ngIf="inputOption === 'DD'">
        Latitude
        <input type="number" [(ngModel)]="latitude" placeholder="Enter Latitude">
    </label>
</div>
<div class="lat-long-container" *ngIf="inputOption === 'DD'">
    <label class="lat-long">
        Longitude
        <input type="number" [(ngModel)]="longitude" placeholder="Enter Longitude">
    </label>
</div>

<div class="lat-long-container"  *ngIf="inputOption === 'DMS'">
    <label class="lat-long">
        Latitude D:
        <input type="number" [(ngModel)]="latitudeDMS.degrees" placeholder="Enter Degrees" (change)="updateLatitudeDMS()">
    </label>
    <label class="lat-long">
        M:
        <input type="number" [(ngModel)]="latitudeDMS.minutes" placeholder="Enter Minutes" (change)="updateLatitudeDMS()">
    </label>
    <label class="lat-long">
        S:
        <input type="number" [(ngModel)]="latitudeDMS.seconds" placeholder="Enter Seconds" (change)="updateLatitudeDMS()">
    </label>
</div>
<div class="lat-long-container" *ngIf="inputOption === 'DMS'">
    <label class="lat-long">
        Longitude D:
        <input type="number" [(ngModel)]="longitudeDMS.degrees" placeholder="Enter Degrees" (change)="updateLongitudeDMS()">
    </label>
    <label class="lat-long">
        M:
        <input type="number" [(ngModel)]="longitudeDMS.minutes" placeholder="Enter Minutes" (change)="updateLongitudeDMS()">
    </label>
    <label class="lat-long">
        S:
        <input type="number" [(ngModel)]="longitudeDMS.seconds" placeholder="Enter Seconds" (change)="updateLongitudeDMS()">
    </label>
</div>

<button id="toggleMap" class="btn btn-transparent" style="margin-bottom:8px;" (click)="toggleMap()">{{ toggleMapButton }}</button>
<div class="lat-long-picker-container" [hidden]="hideMap">
    <span>Click the map to select a Lat/Long</span>
    <div #latLongPicker style="height: 300px; width: 750px;"></div>
</div>
